import { Stack } from '@mui/material';
import MarkButton from './MarkButton';
import BlockButton from './BlockButton';

import CodeIcon from '@mui/icons-material/Code';
import LinkIcon from '@mui/icons-material/Link';

import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import {
    TextBoldLinearIcon,
    TextItalicLinearIcon,
    TextUnderlineLinearIcon
} from '../../icons-lib';

const BUTTONS_CONFIG = {
    "bold": {
        component: MarkButton,
        format: 'bold',
        icon: <TextBoldLinearIcon sx={{ fontSize: '1rem' }} />
    },
    "italic": {
        component: MarkButton,
        format: 'italic',
        icon: <TextItalicLinearIcon sx={{ fontSize: '1rem' }} />
    },
    "underline": {
        component: MarkButton,
        format: 'underline',
        icon: <TextUnderlineLinearIcon sx={{ fontSize: '1rem' }} />
    },
    "link": { component: MarkButton, format: 'link', icon: <LinkIcon /> },
    "code": { component: MarkButton, format: 'code', icon: <CodeIcon /> },

    'heading-one': {
        component: BlockButton,
        format: 'heading-one',
        icon: <LooksOneIcon />
    },
    'heading-two': {
        component: BlockButton,
        format: 'heading-two',
        icon: <LooksTwoIcon />
    },
    'block-quote': {
        component: BlockButton,
        format: 'block-quote',
        icon: <FormatQuoteIcon />
    },
    'numbered-list': {
        component: BlockButton,
        format: 'numbered-list',
        icon: <FormatListNumberedIcon />
    },
    'bulleted-list': {
        component: BlockButton,
        format: 'bulleted-list',
        icon: <FormatListBulletedIcon />
    },

    "left": {
        component: BlockButton,
        format: 'left',
        icon: <FormatAlignLeftIcon />
    },
    "center": {
        component: BlockButton,
        format: 'center',
        icon: <FormatAlignCenterIcon />
    },
    "right": {
        component: BlockButton,
        format: 'right',
        icon: <FormatAlignRightIcon />
    },
    "justify": {
        component: BlockButton,
        format: 'justify',
        icon: <FormatAlignJustifyIcon />
    }
};

export default function Toolbar({ buttons = [], extraButton }) {
    return (
        <Stack
            direction="row"
            spacing={0}
            sx={{
                background: '#F2F4F7',
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                border: 'transparent',
                borderBottom: '1px solid #E0E0E0',
                padding: 1,
                textAlign: 'center'
            }}
        >
            {extraButton}
            {buttons.map((button) => {
                const config = BUTTONS_CONFIG[button];
                if (!config) return null;
                const { component: Component, format, icon } = config;
                return <Component key={format} format={format} icon={icon} />;
            })}
        </Stack>
    );
}
